import GuidedTour from "../GuidedTour";
import { StepType } from "@reactour/tour";

export const DetectSteps: StepType[] = [
  {
    selector: ".Detect .form-area-about",
    position: "right",
    content: (
      <GuidedTour
        title="Describe the company and position"
        content="In the About Company section, provide a brief overview of the organization. This should include the mission, values, and what makes the company a great place to work."
      />
    ),
  },
  {
    selector: ".Detect .form-area-job",
    position: "right",
    content: (
      <GuidedTour
        title="Describe the company and position"
        content="In the Job Description section, provide a detailed description of the job position you're looking includes key responsibilities, required skills, and qualifications."
      />
    ),
  },
  {
    selector: ".Detect .btn-analyze",
    position: "right",
    content: (
      <GuidedTour
        title="Analyze information"
        content="Click analyze to find industries and positions fit with your information."
      />
    ),
  },
  {
    selector: ".Detect .progress-analyze",
    position: "right",
    content: (
      <GuidedTour
        title="Analyze Processing"
        content="Please wait a minute to get keywords."
      />
    ),
  },
  {
    selector: ".Detect .analyze-result-group",
    position: "right",
    content: (
      <GuidedTour
        title="Let Our AI Do the Work"
        content="Once you click `Analyze`, your company and job descriptions will be automatically processed to propose relevant keywords related to your industry and the ideal candidate for the search-engine. You can remove irrelevant keyword with icon."
      />
    ),
  },
  {
    selector: ".Detect .btn-continue",
    position: "right",
    content: (
      <GuidedTour
        title="Continue"
        content="Click continue to come Filter step."
      />
    ),
  },
];
